import o from "./td-longtail-vue-components4.js";
import r from "./td-longtail-vue-components45.js";
import { detectReducedMotionMode as d, isReducedMotion as u } from "./td-longtail-vue-components90.js";
import { useCssVars as m } from "vue";
/* empty css                              */
import c from "./td-longtail-vue-components98.js";
const a = {
  name: "AnimatedGallery",
  components: {
    Controls: r,
    Arrow: o
  },
  props: {
    items: {
      type: Array,
      required: !0
    },
    initialSelectedIndex: {
      type: Number,
      default: 0
    },
    animation: {
      type: String,
      default: "left-fade"
    },
    animationDuration: {
      type: Object,
      default: () => ({
        enter: "0.2s",
        leave: "0.2s"
      })
    },
    autoPlay: {
      type: Boolean,
      default: !1
    },
    autoPlayDuration: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      selectedItemIndex: this.initialSelectedIndex,
      componentTexts: {
        selectItem: "Bild Anzeigen",
        controlGroup: "Navigation",
        prevControl: "Vorheriges",
        nextControl: "Nächstes"
      },
      autoPlayInterval: null,
      isPlaying: !1,
      isReducedMotion: !1
    };
  },
  computed: {
    itemCount() {
      return this.items.length;
    },
    lastItemIndex() {
      return this.itemCount - 1;
    },
    hasMultipleItems() {
      return this.itemCount > 1;
    },
    selectedItem() {
      return this.items[this.selectedItemIndex];
    },
    animationDurationEnter() {
      return this.animationDuration.enter || "0.5s";
    },
    animationDurationLeave() {
      return this.animationDuration.leave || "0.5s";
    },
    pages() {
      const t = [];
      for (let e = 0; e < this.itemCount; e += 1)
        t.push({ number: e, active: e === this.selectedItemIndex });
      return t;
    }
  },
  watch: {
    initialSelectedIndex(t) {
      this.selectItem(t);
    },
    autoPlay: {
      handler(t) {
        if (this.isReducedMotion) {
          this.isPlaying = !1;
          return;
        }
        this.isPlaying = t;
      }
    },
    isPlaying(t) {
      t ? this.startAutoPlay() : this.stopAutoPlay();
    }
  },
  mounted() {
    d(), this.isReducedMotion = u.value, this.isPlaying = this.autoPlay && !this.isReducedMotion;
  },
  methods: {
    selectItem(t) {
      this.selectedItemIndex = Math.max(0, Math.min(t, this.lastItemIndex)), this.resetAutoPlay();
    },
    incrementSelectedItemIndex() {
      if (this.selectedItemIndex === this.lastItemIndex) {
        this.selectItem(0);
        return;
      }
      this.selectItem(this.selectedItemIndex + 1);
    },
    decrementSelectedItemIndex() {
      if (this.selectedItemIndex === 0) {
        this.selectItem(this.lastItemIndex);
        return;
      }
      this.selectItem(this.selectedItemIndex - 1);
    },
    startAutoPlay() {
      this.autoPlayInterval = setTimeout(() => {
        this.incrementSelectedItemIndex();
      }, this.autoPlayDuration * 1e3);
    },
    stopAutoPlay() {
      this.autoPlayInterval && clearTimeout(this.autoPlayInterval);
    },
    resetAutoPlay() {
      this.stopAutoPlay(), this.isPlaying && this.startAutoPlay();
    }
  }
}, n = () => {
  m((t, e) => ({
    "692de640": t.animationDurationEnter,
    "698c2e1f": t.animationDurationLeave
  }));
}, s = a.setup;
a.setup = s ? (t, e) => (n(), s(t, e)) : n;
const h = a;
var I = function() {
  var e = this, i = e._self._c;
  return i("div", { staticClass: "animated-gallery" }, [i("div", { staticClass: "animated-gallery__stage" }, [i("Transition", { attrs: { mode: "out-in", name: e.animation } }, [i("div", { key: e.selectedItemIndex }, [e._t("stageItem", null, { selectedItem: e.selectedItem, index: e.selectedItemIndex }), e.$slots.badge ? [e._t("badge", null, { index: e.selectedItemIndex })] : e._e()], 2)])], 1), e.itemCount > 1 ? i("div", { staticClass: "animated-gallery__controls", attrs: { role: "group", "aria-label": e.componentTexts.controlGroup } }, [i("Arrow", { staticClass: "animated-gallery__arrow", attrs: { "set-position": "", direction: "left", "aria-label": "Vorheriges Bild" }, on: { change: e.decrementSelectedItemIndex } }), i("Arrow", { staticClass: "animated-gallery__arrow", attrs: { "set-position": "", direction: "right", "aria-label": "Nächstes Bild" }, on: { change: e.incrementSelectedItemIndex } })], 1) : e._e(), e.itemCount > 1 ? [e._t("pagination", function() {
    return [i("Controls", { attrs: { "has-play-pause": "", "hide-pages-mobile": "", "infinity-scroll": "", pages: e.pages, "pagination-next": "Nächstes Bild", "pagination-prev": "Vorheriges Bild", "pagination-aria-label": "Bilder-Galerie Paginierung", "pagination-button-label": "Gehe zu Bild %d", "pagination-button-label-first": "Gehe zum ersten Bild", "pagination-button-label-last": "Gehe zum letzten Bild", "play-pause-aria-label": "Animation" }, on: { update: e.selectItem }, model: { value: e.isPlaying, callback: function(l) {
      e.isPlaying = l;
    }, expression: "isPlaying" } })];
  })] : e._e()], 2);
}, p = [], y = /* @__PURE__ */ c(
  h,
  I,
  p,
  !1,
  null,
  "f42bd242"
);
const b = y.exports;
export {
  b as default
};
